// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { FontWeight, Colors } from '../../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {},
  description: {
    fontWeight: `${FontWeight.Bold} !important`,
    color: `${Colors.Blue} !important`,
    margin: '30px 0 !important',
  },
  savings: {
    fontWeight: `${FontWeight.Bold} !important`,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px !important',
  },
  calculationsTitle: {
    fontSize: '18px !important',
    fontWeight: `${FontWeight.Bold} !important`,
    textTransform: 'uppercase',
    marginBottom: '5px !important',
    marginTop: '10px !important',
  },
  calculationsSubTitle: {
    fontSize: '16px !important',
    fontWeight: `${FontWeight.Bold} !important`,
    marginBottom: '5px !important',
    marginTop: '15px !important',
    color: `${Colors.Blue1} !important`,
  },
  sliderContainer: {
    borderBottom: `1px solid ${Colors.Gray5}`,
    marginBottom: 30,
  },
}));

export default useStyles;